{
  "APP_NAME": "EliwellAIR.web",
  "About": "A propos",
  "Hello world !": "Bonjour le monde !",
  "Home": "Accueil",
  "Logged in as": "Connecté en tant que",
  "Login": "Connexion",
  "Logout": "Déconnexion",
  "Password": "Mot de passe",
  "Password is required": "Mot de passe requis",
  "Username": "Identifiant",
  "Username is required": "Identifiant requis",
  "Username or password incorrect.": "Identifiant ou mot de passe incorrect.",
  "Remember me": "Rester connecté",
  "Version": "Version",
  "Profile Update": "Mise à jour du profil",
  "Change Password": "Changer le mot de passe",
  "Change Email": "Changer l'e-mail",
  "Dashboard": "Tableau de bord",
  "Manage": "Gérer",
  "Filter": "Filtre",
  "Search": "Rechercher",
  "Alarms": "Alarmes",
  "Warnings": "Avertissements",
  "Users": "Utilisateurs",
  "Coolers": "Refroidisseurs",
  "Active License": "Licence active",
  "License Expired": "Licence expirée",
  "Grace Period": "Période de grâce",
  "Tenant Users": "Utilisateurs détenteurs",
  "Change Passowrd": "Modifier mot de passe",
  "Rules": "Règles",
  "License Expires On": "Licence expire le",
  "Report": "Rapport",
  "Tenant List": "Liste des détenteurs",
  "Add Tenant": "Ajouter détenteur",
  "Erp No": "N° ERP",
  "Tenant": "Détenteur",
  "License End Date": "Date de fin de licence",
  "Tenant Email": "E-mail du détenteur",
  "ERP Number": "Numéro ERP",
  "Maximum number of coolers": "Nombre maxi de refroidisseurs",
  "License Expiration": "Expiration de licence",
  "Tenant Details": "Informations sur détenteur",
  "TENANT EMAIL": "E-MAIL DU DÉTENTEUR",
  "COOLERS": "REFROIDISSEURS",
  "Expire": "EXPIRE",
  "GEO LOCATION": "GÉO LOCALISATION",
  "ERP NO": "N° ERP",
  "UPDATE": "MISE À JOUR",
  "Disable Tenant": "Désactiver détenteur",
  "Move Coolers": "DÉPLACER REFROIDISSEURS",
  "Do you really want to disable": "Voulez-vous vraiment désactiver",
  "Cooler List": "Liste des refroidisseurs",
  "Search works on COOLER, COUNTRY, TAG/ALIAS columns only": "Rechercher travaux sur colonnes REFROIDISSEUR, PAYS, BALISE/ALIAS uniquement",
  "Cooler": "Refroidisseur",
  "Last Connected": "Dernière connexion",
  "Country": "Pays",
  "Tag/Alias": "Balise/Alias",
  "User Information": "Informations utilisateur",
  "Add New User": "Ajouter nouveaux utilisateurs",
  "Search works on ROLE, EMAIL, CREATE ALARMS, ACCESS TO columns only": "Rechercher travaux sur colonnes RÔLE, E-MAIL, CRÉER ALARMES, ACCÉDER À",
  "Role": "Rôle",
  "Email": "E-mail",
  "Create Alarms": "Créer alarmes",
  "Access To": "Accéder à",
  "Add User Details": "Ajouter détails utilisateur",
  "Edit User Details": "Modifier détails utilisateur",
  "All Countries Selected": "Tous pays sélectionnés",
  "Yes": "Oui",
  "No": "Non",
  "Alarm Information": "Informations d’alarme",
  "Search works on UID, STATUS, COOLER, GEO LOCATION, RULE, ALARM TYPE, RESOURCE columns only": "Rechercher travaux sur colonnes UID, ÉTAT, REFROIDISSEUR, GÉO LOCALISATION, TYPE D’ALARME, RESSOURCE uniquement",
  "UID": "UID",
  "Geo Location": "Géo localisation",
  "Status": "État",
  "Alarm Type": "Type d'alarme",
  "Rule": "Règle",
  "Resource": "Ressource",
  "Alarm Rules": "Règles d’alarme",
  "Add New Rule": "Ajouter nouvelles Règles",
  "Search works on ID, STATUS, ALARM NAME, SEVERITY columns only": "Rechercher travaux sur colonnes ID, ÉTAT, NOM D’ALARME, GRAVITÉ uniquement",
  "All": "Tous",
  "All Controller with Geo Location": "Tout contrôleur avec Géo Localisation",
  "ID": "ID",
  "Alarm Name": "Nom de l’alarme",
  "Limit": "Limite",
  "Severity": "Gravité",
  "BACK": "RETOUR",
  "Last Connected On": "Dernière connexion le",
  "Resources Data": "Données de ressources",
  "Tag Name": "Nom de balise",
  "Update Tag or Alias Name": "Mettre à jour Balise ou Alias",
  "Update": "Mettre à jour",
  "Export": "Exporter",
  "DAY": "JOUR",
  "WEEK": "SEMAINE",
  "MONTH": "MOIS",
  "Loading latest telemetry data ... ": "Chargement des données de télémétrie les plus récentes ... ",
  "Loading telemetry data ... ": "Chargement des données de télémétrie ...",
  "No Data to display": "Pas de données à afficher",
  "Resources": "Ressources",
  "Min": "Mini",
  "Max": "Maxi",
  "Value": "Valeur",
  "Timestamp": "Horodatage",
  "Save": "sauvegarder",
  "Cancel": "Annuler",
  "Save and Apply": "Enregistrer et appliquer",
  "Move": "Bouge toi",
  "Add Alarm Details": "Ajouter détails alarme",
  "Update Alarm Details": "Mettre à jour détails alarme",
  "Controller": "Contrôleur",
  "Limits": "Limites",
  "Notified To": "Notifié à",
  "Apply To": "Appliquer à",
  "Max Distance": "Distance maxi",
  "Controller Name": "Nom du contrôleur",
  "All Controller In": "Tout contrôleur dans",
  "High": "Élevé(e)",
  "Low": "Bas(se)",
  "Parameters": "Paramètres",
  "Parameter": "Paramètre",
  "Select Controller": "Sélectionner contrôleur",
  "Select Controllers": "Sélectionner contrôleurs",
  "Select Resource": "Sélectionner ressources",
  "Success Message": "Message Réussi",
  "Error": "Erreur",
  "Are you sure to Delete User?": "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
  "User deleted successfully.": "Suppression utilisateur réussie.",
  "Invalid Email": "E-mail non valide",
  "Email field should not be empty.": "Champ E-mail ne doit pas être vide.",
  "Email entered is not a valid email.": "L’e-mail saisi n’est pas valide.",
  "Invalid Role": "Rôle non valide",
  "Select a role.": "Sélectionner un rôle.",
  "Updated successfully.": "Mis à jour avec succés.",
  "added successfully.": "ajouté avec succès.",
  "Error occurred while adding user, please try again.": "Erreur survenue pendant ajout d’utilisateur, réessayez.",
  "Invalid Controller": "Contrôleur non valide",
  "Select a Controller": "Sélectionner un contrôleur",
  "Invalid Resource": "Ressource non valide",
  "Select a Resource": "Sélectionner une ressource",
  "Invalid Min Value": "Valeur Mini non valide",
  "Enter a valid Min Value.": "Saisir une valeur Mini valide.",
  "Invalid Max Value": "Valeur Maxi non valide",
  "Enter a valid Max Value.": "Saisir une valeur Maxi valide.",
  "Invalid Max Distance Value": "Valeur Distance maxi non valide",
  "Enter a valid Max Distance Value.": "Saisir une valeur Distance maxi valide.",
  "Invalid Notify Mail Ids": "ID Notifier mail non valides",
  "Enter valid mail Ids.": "Saisir des ID de mail valides.",
  "Select a valid controller in apply to section.": "Sélectionner un contrôleur valide dans section appliquer à.",
  "Invalid Countries": "Pays non valides",
  "Select one or more countries apply to section.": "Sélectionner un ou plusieurs pays dans section appliquer à.",
  "Invalid Rule Name": "Nom de règle non valide",
  "Enter a valid rule name.": "Saisir un nom de règle valide.",
  "added successfully": "ajouté avec succès",
  "updated successfully": "Mis à jour avec succés",
  "Error occurred while adding/updating Rule, please try again.": "Erreur survenue pendant ajout/mise à jour de règle, réessayez.",
  "Activated successfully": "Activé avec succès",
  "Deactivated successfully": "Désactivé avec succès",
  "Deleted successfully.": "Supprimé avec succès.",
  "Are you sure to Delete Rule?": "Êtes-vous sûr de vouloir Supprimer Règle ?",
  "Invalid TenantName": "Nom de détenteur non valide",
  "Tenant Name field should not be empty.": "Champ Nom du détenteur ne doit pas être vide.",
  "Invalid ERP No": "N° ERP non valide",
  "ERP NO field should not be empty.": "Champ N° ERP ne doit pas être vide.",
  "Invalid CoolersCount": "Nombre de refroidisseurs non valide",
  "Please enter valid Coolers": "Veuillez saisir des refroidisseurs valides",
  "Invalid Cooler Value": "Valeur Refroidisseur non valide",
  "Enter a valid Cooler Number Value.": "Saisir une valeur Nombre de refroidisseurs valide.",
  "Invalid Expiry Date": "Date d’expiration non valide",
  "Please select Expiry Date": "Veuillez sélectionner Date d’expiration",
  "Tenant added successfully.": "Ajout de détenteur réussi.",
  "Error occurred while adding tenant, please try again.": "Erreur survenue pendant ajout détenteur, réessayez.",
  "Tenant Updated successfully.": "Mise à jour de détenteur réussie.",
  "Error occurred while updating tenant, please try again.": "Erreur survenue pendant mise à jour détenteur, réessayez.",
  "Reports": "Rapport",
  "Search works on Erp No, Tenant, Geo Location only": "chercher mots uniquement sous Erp No, Tenant et Geo Location",
  "Update Tenant": "Mettre à jour Tenant",
  "Select Expiry License Date": "Sélectionner date d’expiration licence",
  "Registered Tenant": "Tenant enregistrés",
  "Registered Users": "Utilisateurs enregistrés",
  "Users under Tenant": "Utilisateurs présents sous Tenant",
  "Renewal notification sent to Tenant": "Notifications de renouvellement envoyées à Tenant",
  "Number of coolers under Tenant": "Nombre de cooler présents sous Tenant",
  "Date": "Date",
  "Choose Format": "Choisir format",
  "Generate Report": "Créer rapport",
  "Select": "Sélectionner",
  "Active Alarms": "Alarmes actives",
  "Associated Resources": "Ressources associées",
  "Associated Users": "Utilisateurs associés",
  "Coolers List": "Liste des cooler",
  "Device": "appareil",
  "Devices": "Périphériques",
  "User Device Information": "Infos dispositif utilisateur",
  "Mobile Name": "Nom du mobile",
  "Mobile Model": "Modèle du mobile",
  "Legal": "Légal",
  "Privacy Policy": "Politique confidentialité",
  "Copyright": "Droits d'auteur",
  "No Records found": "Aucun enregistrement trouvé",
  "Billing Address": "Adresse de facturation",
  "Search works on Email, Mobile Name, Mobile Model": "La recherche fonctionne sur Email, nom de mobile, modèle de mobile",
  "Are you sure to Delete ?": "Êtes-vous sûr de vouloir supprimer ?",
  "No results found!": "Aucun résultat trouvé!",
  "Select Country": "choisissez le pays",
  "Start Date": "Date de début",
  "End Date": "Date de fin",
  "Select Start Date": "Sélectionnez Démarrer ça",
  "Select End Date": "Sélectionnez la date de fin",
  "Invalid Start Date": "Date de début invalide",
  "Invalid End Date": "Date de fin invalide",
  "Invalid Controllers List": "Liste des contrôleurs non valides",
  "Please wait report is getting ready for Download": "Veuillez patienter, le rapport se prépare pour le téléchargement",
  "downloadFaild": "Échec du téléchargement",
  "Format": "Format",
  "Controllers": "Contrôleurs",
  "Downloads in Progress": "Téléchargements en cours",
  "Do you agree?": "Estás de acuerdo ?",
  "All the files downloaded Successfully": "Tous les fichiers téléchargés avec succès",
  "No files found": "Aucun fichier trouvé",
  "You have cancelled the Downloads": "Vous avez annulé les téléchargements",
  "Warning": "Attention",
  "Driver Manager": "Gestionnaire de pilote",
  "Driver File Name": "Nom du fichier du pilote",
  "Mask": "Masque",
  "Uploaded By": "Telechargé par",
  "Uploaded On": "Téléchargé le",
  "Are you sure to Delete Driver?": "Êtes-vous sûr de supprimer le pilote?",
  "Please upload a valid file": "S'il vous plaît télécharger un fichier valide",
  "Driver file already exists": "Le fichier de pilote existe déjà",
  "Are you sure you want to Overwrite?": "Êtes-vous sûr de vouloir écraser?",
  "Download Success!": "Télécharger le succès!",
  "File Deleted Successfully": "Fichier supprimé avec succès",
  "Trying to upload a non verified driver": "Essayer de télécharger un pilote non vérifié",
  "Driver File Uploaded": "Fichier de pilote téléchargé",
  "File name should not be more than 50 characters": "Le nom du fichier ne doit pas dépasser 50 caractères",
  "Unit": "Mesure",
  "Action": "action",
  "Bad Request": "Mauvaise Demande",
  "Invalid input fields": "Champs de saisie non valides",
  "Invalid Tag Name": "Nom de balise non valide",
  "Coolers by Country": "Refroidisseurs par pays",
  "Enable/Disable": "Activer désactiver",
  "Actions": "Actions",
  "Controller Model": "Mode contrôleur",
  "Selected Resources Data": "Données sur les ressources sélectionnées",
  "Last 24Hr": "24 dernières heures",
  "View Data": "Afficher les données",
  "Note: Maximum of 8 resources are allowed to view data": "Remarque: 8 ressources au maximum sont autorisées pour afficher les données",
  "Get Data": "Obtenir des données",
  "Until": "Jusqu'à",
  "Tag Updated Successfully": "Balise mise à jour avec succès",
  "Add Tag Name..": "Ajouter un nom de balise ...",
  "Select Tenant": "Sélectionnez le locataire",
  "Tenant Disabled Successfully.": "Locataire désactivé avec succès.",
  "Cooler moved successfully.": "Cooler s'est déplacé avec succès.",
  "Unknown error occurred, Please try again.": "Une erreur inconnue s'est produite, veuillez réessayer.",
  "No cooler/coolers availabe to move": "Pas de glacière / glacière disponible pour se déplacer",
  "The target Tenant does not have enough space for the new coolers": "Le locataire cible n'a pas assez d'espace pour la nouvelle glacière",
  "Tenant is not selected": "Le locataire n'est pas sélectionné",
  "Please select Tenant": "Veuillez sélectionner le locataire",
  "Select Countries": "Sélectionnez les pays",
  "Country List": "Liste des pays",
  "Controller List": "Lista de controladores",
  "Notified Email To": "Courriel notifié à",
  "Close": "Fermer",
  "Disable": "Désactiver",
  "Note: Once disabled you can not enable again.": "Remarque: une fois désactivé, vous ne pouvez plus le réactiver.",
  "Delete  Rule": "Supprimer la règle",
  "Delete Device": "Supprimer l'appareil",
  "Ok": "Ok",
  "Hi": "Hello",
  "Commandes": "Commands",
  "Access Restricted Notice!": "Avis d'accès restreint !",
  "Your License has expired. Please Contact your Admin.": "Votre licence a expiré. Veuillez contacter votre administrateur.",
  "Online": "connecté",
  "Offline": "déconnecté",
  "Total": "totale",
  "Processing...": "en cours",
  "Request Process Successfully": "Processus de demande réussi",
  "Error occurred while processing request, please try again.": "Une erreur s'est produite lors du traitement de la demande, veuillez réessayer.",
  "Menu": "Menu",
  "Device Groups": "Groupes d'appareils",
  "HACCP Report": "HACCP Report",
  "Statistics": "Statistiques",
  "Device List": "Liste d'appareils",
  "All Devices": "Tous les appareils",
  "Search works on Device, Groups, Alarms, Country columns": "recherche",
  "Dongle UId": "Edge UID",
  "Active": "Actif",
  "InActive": "Inactif",
  "Group(s)": "groupes",
  "Device Details": "Détails de l'appareil",
  "View Value": "Afficher la valeur",
  "Group Name": "Nom de groupe",
  "Device Name": "nom de l'appareil",
  "Description": "Description",
  "Created Date (UTC)": "Date de création (UTC)",
  "Added By": "Ajouté par",
  "Search works on Group Name, Description columns": "recherche",
  "Add Group Details": "Ajouter les détails du groupe",
  "Edit Group Details": "Modifier détails de groupe",
  "Name of the Group": "Nom du groupe",
  "Create New Group": "Créer nouveau groupe",
  "Select Devices": "Sélectionner Dispositifs",
  "Group Information": "Informations Groupe",
  "Add Description": "Ajouter Description",
  "Device Count": "Nbre de dispositifs",
  "Alarm Count": "Nbre d’alarmes",
  "Device Status": "État dispositif",
  "Group Count": "Nbre de groupe",
  "Groups Count": "Nbre de groupes",
  "Device by Group": "Dispositif par groupe",
  "Alarms By Device Status": "Alarmes par état d’appareil",
  "Device Status Count": "Nbre d’état d’appareil",
  "Alarms By Devices Over Time": "Alarmes par appareils en fonction du temps",
  "Real Time": "Temps effectif",
  "Last 24 Hrs": "Dernières 24 h",
  "Last Week": "Semaine dernière",
  "Last Month": "Mois dernier",
  "Last 3 Months": "3 derniers mois",
  "Last 1 Year": "Année dernière",
  "Last 6 Months": "6 derniers mois",
  "OEM": "OEM",
  "Name": "Nom",
  "OEM\/Parent": "OEM\/Parent",
  "Create Users": "Créer Utilisateurs",
  "Selected Countries": "Pays sélectionnés",
  "Selected Devices": "Appareils sélectionnés",
  "Enabled": "Activé(e)",
  "Disabled": "Désactivé(e)",
  "Groups": "Groupes",
  "Groups List": "Listes des groupes",
  "Select Groups": "Sélectionner Groupes",
  "Telemetry": "Télémétrie",
  "Filters": "Filtres",
  "Show Favorites": "Afficher Favoris",
  "Favorites": "Favoris",
  "Favourites": "Favoris",
  "Label": "Libellé",
  "Current Value": "Valeur courante",
  "Operations": "Opérations",
  "Read All": "Lire Tout",
  "Settings": "Configurations",
  "Set Value": "Définir valeur",
  "Mobile UId": "Uid Mobile",
  "Mobile OS | Version": "OS Mobile | Version",
  "Issued On": "Publié le",
  "Active Device(s)": "Dispositif(s) actif(s)",
  "In-active Device(s)": "Dispositif(s) inactif(s)",
  "Block User": "Bloquer Utilisateur",
  "Unblock User": "Débloquer Utilisateur",
  "Driver Upload": "Télécharg. conducteur",
  "Search works on Driver File Name, Mask, and Uploaded By columns": "Chercher travaux sur colonnes Nom Fichier Conducteur, Masque, et Téléchargés par",
  "Search works on Report Name,Report Frequency, and Notified Email columns": "Chercher travaux sur colonnes Nom de rapport, Fréquence Rapports, et E-mail Notifié",
  "Add new report": "Ajouter nouveau Rapport",
  "Report Name": "Nom de Rapport",
  "Report Frequency": "Fréquence de Rapport",
  "Daily": "Journalier(e)",
  "Weekly": "Hebdomadaire",
  "Monthly": "Mensuel(le)",
  "Data Frequency": "Fréquence des données",
  "PDF": "PDF",
  "CSV": "CSV",
  "XLSX": "XLSX",
  "Delete Report :": "Supprimer Rapport :",
  "Add Report": "Ajouter Rapport",
  "Update Report Details": "Mettre à jour Détails Rapport",
  "Select Data Frequency": "Sélectionner Fréquence des données",
  "One time per day": "Une fois par jour",
  "Two times per day": "Deux fois par jour",
  "Three time per day": "Trois fois par jour",
  "Four times per day": "Quatre fois par jour",
  "Select Device": "Sélectionner Dispositifs",
  "Data Frequency is Mandatory": "Fréquence de données est obligatoire",
  "Device is Mandatory": "Dispositif est obligatoire",
  "Resource is Mandatory": "Ressource est obligatoire",
  "Notified to email is Mandatory": "Notifié à e-mail est obligatoire",
  "Maximum 8 resources can be selected": "8 ressources maximum peuvent être sélectionnées",
  "Invalid OEM": "OEM Invalide",
  "Select an OEM": "Sélectionner un EOM",
  "User already exist": "Utilisateur existe déjà",
  "Email or Role is not valid": "E-mail ou Rôle n’est pas valide",
  "You are currently blocked. Please contact system administrator for details or to restore access. <System Admin EMAIL ID>": "Vous êtes actuellement bloqué. Veuillez contacter l’administrateur système pour des détails ou pour restaurer l’accès. <ID EMAIL Admin Système>",
  "Invalid Device": "Dispositif Invalide",
  "Invalid Group": "Groupe Invalide",
  "Error Deleting Alarm Rule": "Erreur Suppression Règle d’alarme",
  "Are you sure to Block ?": "Êtes-vous sûr de vouloir bloquer ?",
  "Are you sure to Unblock ?": "Êtes-vous sûr de vouloir débloquer ?",
  "Error downloading driver file": "Erreur téléchargement fichier conducteur",
  "Group deleted successfully": "Suppression de groupe réussie",
  "Failed to delete group": "Échec suppression de groupe",
  "Group created successfully": "Création de groupe réussie",
  "Group details updated successfully": "Mise à jour détails de groupe réussie",
  "Failed to create\/edit group": "Échec création\/modification de groupe",
  "Group Name already exist": "Nom de groupe existe déjà",
  "Group Name already exist\/duplicate Group Name": "Nom de groupe existe déjà\/dupliquer nom de groupe",
  "Model is not valid": "Modèle non valide",
  "Name\/Desc is not valid": "Nom\/Desc n’est pas valide",
  "One\/More selcted device is invalid or the user doesn't have access": "Un\/plusieurs dispositif(s) sélectionné(s) non valide(s) ou l’utilisateur n’a pas accès",
  "User has no access to the group": "Utilisateur n’a pas accès au groupe",
  "Failed to fetch data": "Échec récupération données",
  "Error deleting file ": "Erreur suppression données ",
  "Error occurred while adding\/updating Report, please try again.": "Erreur survenue pendant ajout\/mise à jour de rapport, réessayez.",
  "Are you sure to Delete Report?": "Êtes-vous sûr de vouloir supprimer ce rapport ?",
  "Error Deleting Report": "Erreur suppression rapport",
  "User has no access to the Haccp Report": "Utilisateur n’a pas accès au rapport HACCP",
  "Report name is not valid": "Nom de rapport non valide",
  "Invalid Controller type": "Type de contrôleur non valide",
  "Duplicate report name": "Dupliquer nom de rapport",
  "Add OEM": "Ajouter un OEM",
  "Phone/Tablet": "Téléphone/Tablette",
  "Data Export": "Exportation de données",
  "Export Json": "Exporter Json",
  "Support": "Soutien",
  "FAQ's": "FAQ",
  "History": "Histoire",
  "v3.2": "v3.2",
  "Terms and Conditions": "Termes et conditions",
  "Search works on OID,OEM Name,OEM Description": "La recherche fonctionne sur l'OID, le nom OEM, la description OEM",
  "OEM Description": "la description OEM",
  "OEM Name": "le nom OEM",
  "OID": "OID",
  "Map View": "Vue de la carte",
  "Upload": "Télécharger",
  "Count": "Compter",
  "Commands": "Commandes",
  "Labels": "French",
  "Added On": "Ajouté le",
  "Modbus slave ID": "ID esclave Modbus",
  "Controller Type Name": "Désignation type de contrôleur",
  "Device Type": "Type de dispositif",
  "Day": "Jour",
  "Hour": "Heure",
  "Start": "Démarrer",
  "End": "Fin",
  "Poli": "Poli",
  "Mask": "Masque",
  "Release": "Version",
  "PCH": "PCH",
  "Location": "Location",
  "Dsp Id": "ID Dsp",
  "Firmware Version": "Version du microprogramme",
  "Device Metadata": "Métadonnées dispositif",
  "Alarms count by device's status": "Nombre d’alarmes par état dispositif",
  "Alarms count group by device's status and device": "Groupe nombre d’alarmes par état dispositif et dispositif",
  "Alarm Count distribution over time": "Distribution nombre d’alarmes au fil du temps",
  "Alarm status count over time": "Nombre état d’alarme au fil du temps",
  "Device by Controller Model": "Dispositif par Modèle contrôleur",
  "Select columns": "Sélectionner colonnes",
  "columns selected": "colonnes sélectionnées"


}
